import { Empty, Icon, message, Upload } from 'antd';
import React from 'react';
import styles from './ContentDocsPermit.module.scss';
import { maxFileSize } from '../../../../../../constants/maxFileSize';
import useAddDoc from '../../api/useAddDoc';
import { CardButton } from '../../../../../../components/Card';
import DocListPermit from '../DocListPermit/DocListPermit';

export const documentsAllowedExtensions = [
  'jpg',
  'pdf',
  'doc',
  'docx',
  'jpeg',
  'png',
  'raw',
  'tiff',
  'bmp',
];

const beforeUpload = (file) => {
  const fileExtension = file.name.split('.').pop().toLowerCase();

  if (!documentsAllowedExtensions.includes(fileExtension)) {
    message.error(`Файл ${file.name} имеет недопустимый формат.`);
    return false;
  }

  if (file.size > maxFileSize) {
    message.error(`Файл ${file.name} весит больше 15 мб.`);
    return false;
  }

  return true;
};

const ContentDocsPermit = ({ permitId, data = [] }) => {
  const { mutateAsync, isLoading } = useAddDoc();

  const customRequest = async ({ file }) => {
    await mutateAsync({ permitId, file });
  };

  return (
    <div className={styles.root}>
      {!!data?.length ? (
        <DocListPermit
          permitId={permitId}
          data={data}
        />
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Нет документов"
        />
      )}
      <Upload.Dragger
        className={styles.upload}
        multiple
        beforeUpload={beforeUpload}
        customRequest={customRequest}
        showUploadList={false}
      >
        {isLoading ? (
          <Icon type="loading" />
        ) : (
          <CardButton
            className={styles.btn}
            text="Добавить документ"
          />
        )}
      </Upload.Dragger>
    </div>
  );
};

export default ContentDocsPermit;
